import { render, staticRenderFns } from "./Impersonation.vue?vue&type=template&id=1573971c&lang=pug&"
import script from "./Impersonation.vue?vue&type=script&lang=js&"
export * from "./Impersonation.vue?vue&type=script&lang=js&"
import style0 from "./Impersonation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1573971c')) {
      api.createRecord('1573971c', component.options)
    } else {
      api.reload('1573971c', component.options)
    }
    module.hot.accept("./Impersonation.vue?vue&type=template&id=1573971c&lang=pug&", function () {
      api.rerender('1573971c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Impersonation.vue"
export default component.exports